import { render, staticRenderFns } from "./KilomCamRapp.vue?vue&type=template&id=120b2dba&scoped=true&"
import script from "./KilomCamRapp.vue?vue&type=script&lang=js&"
export * from "./KilomCamRapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120b2dba",
  null
  
)

export default component.exports